import type { SVGProps } from "react";
const SvgAdd01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="M10 3.333v13.334M3.333 10h13.334"
    />
  </svg>
);
export default SvgAdd01;
